import { useEffect } from "react";
import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { EmployeeForm } from "@/components/payroll/EmployeeForm";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute("/companies/$companyId/nomina/empleados/new")({
  component: NewEmployeePage,
});

function NewEmployeePage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewEmployeeContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewEmployeeContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const navigate = useNavigate();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4">
      <Link
        to="/companies/$companyId/nomina/empleados"
        params={{ companyId }}
        className="inline-flex w-fit items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        {t("payroll.employee.new.back")}
      </Link>
      <h1 className="text-2xl font-semibold tracking-tight">
        {t("payroll.employee.new.title")}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t("payroll.employee.new.subtitle")}
      </p>

      <EmployeeForm
        mode={{ kind: "create", companyId }}
        onCreated={(e) => {
          void navigate({
            to: "/companies/$companyId/nomina/empleados/$employeeId",
            params: { companyId, employeeId: e.id },
          });
        }}
      />
    </div>
  );
}
